var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersTitleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#users_title_icon_svg__clip0_236_1877)",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.917 31.25v-3.167a6.333 6.333 0 00-6.334-6.333H8.917a6.333 6.333 0 00-6.334 6.333v3.167M15.25 15.417a6.333 6.333 0 100-12.667 6.333 6.333 0 000 12.667zM37.417 31.25v-3.167a6.333 6.333 0 00-4.75-6.127M26.333 2.956a6.333 6.333 0 010 12.27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "users_title_icon_svg__clip0_236_1877"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v34H0z"
  })))));
}
export default SvgUsersTitleIcon;